import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavbarUiService {
  readonly mobileMenuOpen = signal(false);

  toggleMobileMenu(): void {
    this.mobileMenuOpen.update((open) => !open);
    this.syncBodyState();
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen.set(false);
    this.syncBodyState();
  }

  private syncBodyState(): void {
    const open = this.mobileMenuOpen();
    document.body.style.overflow = open ? 'hidden' : '';
    document.body.classList.toggle('mobile-nav-open', open);
  }
}
